import { Component, OnInit, HostListener, AfterViewInit } from '@angular/core';
import { BaseComponent } from '../../base-component';
import { EventService } from '../../service/event.service';
import { Router } from '@angular/router';
import { ChangeNavigationEvent, ValidateAndNavigateEvent, BeforeSubmitErrorEvent, ProgressBarEvent, SkipToMainContentEvent } from '../../service/events';
import { AFDisclosure, AF_CONSTANTS } from '../../model/af.model';
import { AuthService } from '../../service/auth.service';
import { ConsentService } from '../../service/consent.service';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { CustomValidatorsService } from '../../service/custom-validators.service';
import { DatePipe } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-br-acknowledgement',
  templateUrl: './br-acknowledgement.component.html',
  styleUrls: ['./br-acknowledgement.component.scss']
})
export class BrAcknowledgementComponent extends BaseComponent implements OnInit, AfterViewInit {

  signatureImg: string; // @Input wet-signature
  ackData: UntypedFormGroup;
  afDisclosureInfo: AFDisclosure;
  authLanguageLookup: string;
  ackTerms: string;
  date: any;
  termDate: any;
  check: boolean = false;
  checkTwo: boolean = false;
  sigCheckValue: boolean = false;
  hasBeenSubmittted: boolean = false;
  regexName: RegExp = /^[A-Za-z\u00C0-\u017F\-',. ]+$/;

  constructor(private eventBus: EventService, private _router: Router, private userService: AuthService,
    private consentService: ConsentService, private fb: UntypedFormBuilder, private customValidator: CustomValidatorsService,
    private datepipe: DatePipe, private _snackBar: MatSnackBar) {
    super(eventBus, _router);
  }

  ngOnInit(): void {
    this.createGroup();
    this.subscribeEvents();
  }

  subscribeEvents() {
    this.consentService.getAfDisclosure().subscribe((data: AFDisclosure) => {
      this.afDisclosureInfo = data;
      this.ackData.patchValue(data);
      this.authLanguageLookup = data.authLanguageLookup;
      this.signatureImg = data.output;
      this.date = data.legalRequirementCheckDate;
      this.termDate = data.discTermsCheckDate;
      this.setLanguage();
    });

    this.legalRequirementsMet.valueChanges.subscribe(() => {
      this.setDate();
    });

    this.discTermsCheck.valueChanges.subscribe(() => {
      this.setTermDate();
    });

    this.sub = this.eventBus.on(
      ValidateAndNavigateEvent,
      (event): void => {
        this.bookmarkUrl.setValue("");
        if (event.payload.currentLink === '/br-acknowledgement') {
          this.bookmarkUrl.setValue("");
          if (event.payload.save) {
            this.submitafDisclosureInfo((this.ackData.value), event);
          } else if (event.payload.saveAndFinishLater) {
            this.bookmarkUrl.setValue(event.payload.currentLink);
            this.submitafDisclosureInfo((this.ackData.value), event);
          } else {
            if (this.validate()) {
              this.submitafDisclosureInfo((this.ackData.value), event);
            } else {
              this.eventBus.emit(new BeforeSubmitErrorEvent({}));
            }
          }
        }
      }
    );

  }

  ngAfterViewInit() {
    this.ackData.valueChanges.subscribe(() => {
      setTimeout(() => {
        let progress = this.getPercentage(this.ackData);
        this.eventBus.emit(new ProgressBarEvent({ id: progress }));
      }, 100);
    });

    // retain navigation on page refresh
    let navlink = this.userService.getNavLinks().find(e => e.routerLink === "/br-acknowledgement");
    this.eventBus.emit(new ChangeNavigationEvent({ id: navlink.id }));
  }

  get output() { return this.ackData.get('output') }
  get legalRequirementsMet() { return this.ackData.get('legalRequirementsMet') }
  get applicantSignedName() { return this.ackData.get('applicantSignedName') }
  get discTermsCheck() { return this.ackData.get('discTermsCheck') }
  get bookmarkUrl() { return this.ackData.get('bookmarkUrl') }

  createGroup() {
    this.ackData = this.fb.group({
      output: ['', Validators.required],
      applicantSignedName: ['', [Validators.required, Validators.maxLength(250), Validators.pattern(this.regexName), this.customValidator.validateRequiredField]],
      legalRequirementsMet: ['', Validators.requiredTrue],
      discTermsCheck: ['', Validators.requiredTrue],
      bookmarkUrl: ['']
    });
  }

  setLanguage() {
    this.ackTerms = this.afDisclosureInfo.languageLookup['ACKNOWLDGMENT_TERMS'];
  }

  submitafDisclosureInfo(afDisclosureInfo: AFDisclosure, event) {
    afDisclosureInfo.output = this.signatureImg;
    afDisclosureInfo.afId = this.userService.getAfId();
    afDisclosureInfo.legalRequirementCheckDate = this.date;
    afDisclosureInfo.discTermsCheckDate = this.termDate;
    afDisclosureInfo.discStatsCheckDate = this.termDate;

    this.consentService.saveAfDisclosure(afDisclosureInfo).subscribe({
      next: () => {
        if (event.payload.save) {
          this._snackBar.open("Saved successfully", "Close", {
            duration: 4000,
          });
        } else if (event.payload.saveAndFinishLater) {
          this._snackBar.open("Saved successfully", "Close", {
            duration: 4000,
          });
          this._router.navigate(['sessionTimedOut']);
        } else {
          this.eventBus.emit(new ChangeNavigationEvent({ id: event.payload.id }));
          this._router.navigateByUrl(event.payload.nextNavLink);
        }
      },
      error: (error: any) => console.log(error)
    });
  }

  getPercentage(container: UntypedFormGroup): number {
    let errorCount = 0;
    let totalCount = 0;

    for (let controlKey in container.controls) {
      if (container.controls.hasOwnProperty(controlKey)) {
        if (container.controls[controlKey].validator != null) {
          totalCount += container.controls[controlKey].validator.length;
        }
        if (container.controls[controlKey].errors) {
          errorCount += Object.keys(container.controls[controlKey].errors).length;
        }
      }
    }
    return ((totalCount - errorCount) / totalCount) * 100;
  }

  validate() {
    this.ackData.markAllAsTouched();

    this.hasBeenSubmittted = true;

    if (!this.legalRequirementsMet.value) {
      this.legalRequirementsMet.setErrors({ invalid: true });
      this.checkTwo = true;
    }

    if (!this.discTermsCheck.value) {
      this.discTermsCheck.setErrors({ invalid: true });
      this.check = true;
    }

    if (!this.output.value) {
      this.output.setErrors({ invalid: true });
    }

    if (this.ackData.invalid) {
      return false;
    }

    return true;
  }

  onFocusOutMainContent(event) {
    this.eventBus.emit(new SkipToMainContentEvent({ text: "FocusOff" }));
  }

  print() {
    let printElement = document.getElementById('print-section');
    let printContents = printElement.innerHTML;
    let popupWin = window.open("", "_blank", "top=0,left=0,height=auto,width=auto");

    popupWin.document.open();
    popupWin.document.write("\n      <html>\n        <head>\n          <title>" + ("") + "</title>        </head>\n        <body onload=\"window.print(); setTimeout(function(){ window.close(); }, 0)\">\n          " + printContents + "\n        </body>\n      </html>");
    popupWin.document.close();
  }

  getUrl(sig: string) {
    this.signatureImg = sig; // Gets the base64 String from wet-signature @Output
    this.ackData.get('output').setValue(sig);
  }

  sigCheck(sigCheck: boolean) {
    this.sigCheckValue = sigCheck;
  }

  termsOnBlur() {
    if (this.discTermsCheck.value) {
      this.check = false;
    } else {
      this.check = true;
    }
  }

  termsOnFocus() {
    this.check = false;
  }

  legalOnBlur() {
    if (this.legalRequirementsMet.value) {
      this.checkTwo = false;
    } else {
      this.checkTwo = true;
    }
  }

  legalOnFocus() {
    this.checkTwo = false;
  }

  setDate() {
    if (this.legalRequirementsMet.value) {
      if (!this.date) {
        if (!this.afDisclosureInfo.legalRequirementCheckDate) {
          this.date = this.datepipe.transform(new Date(), 'MM/dd/yyyy HH:mm:ss');
        }
      }
    } else {
      if (!this.afDisclosureInfo.legalRequirementCheckDate) {
        this.date = null;
      }
    }
  }

  setTermDate() {
    if (this.discTermsCheck.value) {
      if (!this.termDate) {
        if (!this.afDisclosureInfo.discTermsCheckDate) {
          this.termDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy HH:mm:ss');
        }
      }
    } else {
      if (!this.afDisclosureInfo.discTermsCheckDate) {
        this.termDate = null;
      }
    }
  }
}
